import React from 'react';
import Button from '../../@base/Button';
import Input from '../../@base/Input';
import Checkbox from '../../@base/Checkbox';
import Select from '../../@base/Select';
import SelectOption from '../../@base/SelectOption';

import { objectFlip } from '../../../utils/functions';

/** Componente de detalhamento pergunta e resposta */
const AnswersOptionListComponent = (props) => {
  const displayTypeDict = {
    button: 'Botões',
    selection: 'Lista',
    dropdown: 'Menu Dropdown',
  };

  const displayTypeDictFliped = objectFlip(displayTypeDict);

  let { options } = props;
  const { display } = props;
  const { title } = props;

  if (options === undefined) {
    options = [{
      label: '',
      value: '',
      showValue: false,
    }];
  }

  if (options[options.length - 1].label !== '' || options[options.length - 1].value !== '') {
    options = [...options, {
      label: '',
      value: '',
      showValue: false,
    }];
  }

  const optionsCount = options.length;

  const handelChangeTitle = (e) => {
    const { value } = e.target;
    if (title !== value) {
      const updatedOptions = { ...props };
      updatedOptions.title = value;
      props.update(updatedOptions);
    }
  };

  const handleDisplayTypeChange = (e) => {
    const value = displayTypeDictFliped[e];
    if (display === value) return null;
    const updatedOptions = { ...props };
    updatedOptions.display = value;
    props.update(updatedOptions);
  };

  const handleLabelChange = (idx, e) => {
    const { value } = e.target;
    if (options[idx].label !== value) {
      const updatedOptions = { ...props };
      updatedOptions.options = options;
      updatedOptions.options[idx].label = value;
      props.update(updatedOptions);
    }
  };

  const handleValueChange = (idx, e) => {
    const { value } = e.target;
    if (options[idx].value !== value) {
      const updatedOptions = { ...props };
      updatedOptions.options = options;
      updatedOptions.options[idx].value = value;
      props.update(updatedOptions);
    }
  };

  const handleShowValueChange = (idx) => {
    const updatedOptions = { ...props };
    updatedOptions.options = options;
    updatedOptions.options[idx].showValue = !updatedOptions.options[idx].showValue;
    props.update(updatedOptions);
  };

  const handleRemoveOption = (index) => {
    const updatedOptions = { ...props };
    updatedOptions.options = options;
    updatedOptions.options.splice(index, 1);
    props.update(updatedOptions);
  };

  return (
    <>
      <div className="row mb-4">
        <div className="col-7 ml-2 mr-3">
          <Input
            placeholder="Escreva o título da lista"
            inline
            label="Título:"
            value={title}
            onChange={handelChangeTitle}
          />

        </div>
        <div className="col-4">
          <Select
            label="Tipo:"
            inline
            labelWidth="40"
            value={displayTypeDict[display]}
            onChange={handleDisplayTypeChange}
          >
            {Object.entries(displayTypeDict)
              .map(([key, value]) => (
                <SelectOption key={key} title={value} selected={display === key}>
                  {value}
                </SelectOption>
              ))}

          </Select>
        </div>
      </div>

      <div className="item-list option">
        <div className="options-list options-list-faq">
          <div>
            <div />
            <div>Rótulo:</div>
            <div>Valor:</div>
            <div>Mostrar Valor:</div>
            <div />
          </div>

          {options && options.map((el, i) => (
            <div key={i}>
              <div>{i < optionsCount && i + 1}</div>
              <div>
                <Input
                  placeholder="Escreva o rótulo"
                  value={el.label}
                  onChange={(e) => handleLabelChange(i, e)}
                />
              </div>
              <div>
                <Input
                  placeholder="Escreva o valor"
                  value={el.value}
                  onChange={(e) => handleValueChange(i, e)}
                />
              </div>
              <div>
                <Checkbox
                  onClick={() => handleShowValueChange(i)}
                  checked={el.showValue}
                />
              </div>
              <div>
                {i < optionsCount
                && (
                  <Button
                    small
                    circle
                    title="Apagar opção"
                    onClick={() => handleRemoveOption(i)}
                    disabled={(el.label === '' && el.value === '') || options.length <= 2}
                  >
                    <span>
                      <i className="fa fa-times" aria-hidden="true" />
                    </span>
                  </Button>
                )}
              </div>
            </div>
          ))}

        </div>
        <div />
      </div>
    </>
  );
};

export default AnswersOptionListComponent;
